import * as React from "react";
import { forwardRef } from "react";
const SvgBilling = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-credit-card-icon lucide-credit-card", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 14, x: 2, y: 5, rx: 2 }), /* @__PURE__ */ React.createElement("line", { x1: 2, x2: 22, y1: 10, y2: 10 }));
const ForwardRef = forwardRef(SvgBilling);
export default ForwardRef;
